import React from 'react'
import './Location.css'
import './Home.css'
import { useEffect } from 'react'


function TermsAndConditions() {
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on page load
    }, []);
    return (
        <div className='location-main'>
            <div className='container-fluid'>
                <div className="container py-5">
                    <h1 className="text-center syne-title mb-4">Terms & Conditions<span className='text-rose'>.</span></h1>

                    <div className="row justify-content-center">
                        <div className="col-md-10">
                            <p className='text-secondary'>
                                Welcome to Zamindaar. By accessing or using our website and services, you agree to comply with the following Terms & Conditions. Please read them carefully before proceeding.
                            </p>

                            <h4 className='syne-title py-3'>Scope of Services</h4>
                            <p className='text-secondary'>
                                Zamindaar offers comprehensive real estate solutions, including property consulting, land acquisition, market intelligence, project marketing, and investment advisory. Our aim is to guide you through your real estate journey with integrity and insight.
                            </p>

                            <h4 className='syne-title py-3'>User Responsibilities</h4>
                            <p className='text-secondary'>
                                As a user of Zamindaar’s platform, you agree to:
                                <ul className='list-unstyled'>
                                    <li className='my-2'><i className="fas fa-check-double text-rose me-2"></i>Use our website and services for lawful and legitimate purposes only.</li>
                                    <li className='my-2'><i className="fas fa-check-double text-rose me-2"></i>Provide true, current, and accurate information when required.</li>
                                    <li className='my-2'><i className="fas fa-check-double text-rose me-2"></i>Refrain from engaging in any unauthorized, unethical, or unlawful activity on our platform.</li>
                                </ul>
                            </p>

                            <h4 className='syne-title py-3'>Limitation of Liability</h4>
                            <p className='text-secondary'>
                                While Zamindaar strives to provide accurate and up-to-date information, we do not guarantee the completeness or reliability of all content. We are not liable for any direct or indirect loss or damage arising from the use of our website or services.
                            </p>

                            <h4 className='syne-title py-3'>Intellectual Property</h4>
                            <p className='text-secondary'>
                                All content—including logos, images, text, graphics, and other material—on Zamindaar’s website is the intellectual property of Zamindaar. Any unauthorized use, reproduction, or distribution is strictly prohibited and may result in legal action.
                            </p>

                            <h4 className='syne-title py-3'>Service Termination</h4>
                            <p className='text-secondary'>
                                Zamindaar reserves the right to suspend or terminate access to our services at any time if we believe there has been a violation of these Terms & Conditions.
                            </p>

                            <h4 className='syne-title py-3'>Amendments</h4>
                            <p className='text-secondary'>
                                We may revise these Terms & Conditions periodically to reflect changes in our services or policies. Continued use of the platform after such updates constitutes your acceptance of the new terms.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Contact Section */}
            <div className='container-fluid py-5 home-discuss'>
                <div className='container py-5 home-discuss-inner bg-light p-4 rounded-15 shadow-sm'>
                    <h1 className='syne-title mb-4 text-start'>
                        LET'S DISCUSS<br />YOUR VISION<span className='text-rose'>.</span>
                    </h1>
                    <div className='discuss-inner'>
                        <div className='row align-items-center'>
                            <div className='col-lg-6'>
                                <div className='discuss-left text-start'>
                                    <p className='text-secondary'>
                                        We’d love to hear about your plans! Whether you're just exploring ideas or ready to start, Zamindaar is here to guide you every step of the way. Reach out today to schedule a consultation.
                                    </p>
                                    <div className='discuss-mail d-flex align-items-center my-3'>
                                        <i className='fas fa-envelope me-2'></i>
                                        <p className='mb-0 text-secondary'>connect@zamindaar.in</p>
                                    </div>
                                    <div className='discuss-mail d-flex align-items-center my-3'>
                                        <i className='fas fa-mobile-alt me-2'></i>
                                        <p className='mb-0 text-secondary'>+91 98765 43210</p>
                                    </div>
                                    <div className='discuss-mail d-flex align-items-center my-3'>
                                        <i className='fas fa-map-marker-alt me-2'></i>
                                        <p className='mb-0 text-secondary'>123, Real Estate Hub, Financial District, Hyderabad</p>
                                    </div>
                                    <div className='discuss-icons d-flex'>
                                        <a href='https://linkedin.com/company/zamindaar' target='_blank' className='text-decoration-none'>
                                            <i className='fab fa-linkedin-in text-white'></i>
                                        </a>
                                        <a href='https://x.com/zamindaar' target='_blank' className='text-decoration-none'>
                                            <i className='fab fa-twitter text-white'></i>
                                        </a>
                                        <a href='https://facebook.com/zamindaar' target='_blank' className='text-decoration-none'>
                                            <i className='fab fa-facebook-f text-white'></i>
                                        </a>
                                        <a href='https://instagram.com/zamindaar.in' target='_blank' className='text-decoration-none'>
                                            <i className='fab fa-instagram text-white'></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-6'>
                                <form action="https://api.web3forms.com/submit" method="POST">
                                    <input type="hidden" name="access_key" value="d567d7ce-8cc7-4fdd-a9ae-66c9c3461e68" />
                                    <input type='text' placeholder='Your Name' name="name" className='form-control my-2' required />
                                    <input type='text' placeholder='Phone Number' name="mobile" className='form-control my-2' required />
                                    <input type='email' placeholder='Email Address' name="email" className='form-control my-2' required />
                                    <textarea placeholder='Your Message' name="message" rows='4' className='form-control my-2' required />
                                    <div className='text-start mt-3 d-flex align-items-center'>
                                        <span className='fs-2 text-rose'>→</span>
                                        <input type='submit' value='Send Message' className='border-0 text-rose discuss-btn' />
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default TermsAndConditions